import { useEffect, useRef } from 'react';
import { services } from '../../../mocks/servicesData';

export default function ServicesGrid() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('opacity-100', 'translate-y-0'); },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const handleScroll = (id: string) => {
    const el = document.querySelector(`#service-detail-${id}`);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="w-full bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700"
        >
          {/* Header */}
          <div className="text-center mb-12">
            <span className="inline-block text-emerald-600 font-semibold text-sm uppercase tracking-widest mb-3">
              Hizmetlerimiz
            </span>
            <h2
              className="text-3xl md:text-5xl font-extrabold text-[#1a1a1a] leading-tight"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Uzman Ekiple Tam Temizlik
            </h2>
            <p className="text-gray-500 mt-3 text-base md:text-lg max-w-xl mx-auto">
              Tüm hizmetler Alman Karcher ekipmanı ve özel kimyasallar ile uygulanır.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((s, i) => (
              <div
                key={s.id}
                className="group bg-white border border-gray-100 rounded-2xl p-7 flex flex-col items-start hover:-translate-y-2 transition-all duration-300 hover:border-emerald-200 hover:shadow-lg"
                style={{ animationDelay: `${i * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-14 h-14 flex items-center justify-center bg-emerald-50 rounded-2xl mb-5 group-hover:bg-emerald-500 transition-colors">
                  <span className="w-7 h-7 flex items-center justify-center">
                    <i className={`${s.icon} text-2xl text-emerald-600 group-hover:text-white transition-colors`} />
                  </span>
                </div>

                {/* Title */}
                <h3 className="font-bold text-[#1a1a1a] text-lg mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {s.title}
                </h3>

                {/* Desc */}
                <p className="text-gray-500 text-sm leading-relaxed flex-1 mb-5">
                  {s.shortDesc}
                </p>

                {/* Link */}
                <button
                  onClick={() => handleScroll(s.id)}
                  className="flex items-center gap-1.5 text-emerald-600 font-semibold text-sm group-hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
                >
                  Detaylı Bilgi
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
